import { cmsAxios } from "./config/axiosConfig";

export const getProctorRequests = async (): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    const response = await cmsAxios.get("/cms/proctor-request/list");
    return {
      success: true,
      data: response.data.data, // adjust if response shape differs
    };
  } catch (error: any) {
    console.error("Error fetching proctor requests:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Something went wrong",
    };
  }
};

export const updateProctorRequestStatus = async (
  requestId: string,
  status: "approved" | "reject",
  message: string | null = null
): Promise<{ success: boolean; data: string }> => {
  try {
    const res = await cmsAxios.put(`/cms/proctor-request/${requestId}`, {
      status,
      message,
    });
    return res.data;
  } catch (error) {
    console.error("Failed to update proctor request status:", error);
    throw error;
  }
};
